/** 保存時間顯示（YYYY-MM-DD HH:mm，本地時區）。 */
function formatSavedAt(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

interface ReportSavedBannerProps {
  /** 保存時間（Backend created_at） */
  savedAt: string;
  /** 這份歷史報告建立於歷史追蹤功能（Batch 7-C）啟用前，不會自動出現在新的歷史紀錄列表。 */
  legacy?: boolean;
  /** 返回目前 session 的即時報告 */
  onReturnToLive: () => void;
}

/**
 * 歷史 Snapshot 讀回時的頂部提示（Batch 7-B2B / 7-C）。
 * 低調標示「已保存報告 + 保存時間」；不顯示 saveRequestId / internal audit id / schema 細節。
 */
export default function ReportSavedBanner({ savedAt, legacy = false, onReturnToLive }: ReportSavedBannerProps) {
  const timeText = formatSavedAt(savedAt);
  return (
    <section className="ds-container pt-12 md:pt-16">
      <div className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-accent-200 bg-accent-50/70 p-5 shadow-card md:p-6">
        <div className="flex items-center gap-3.5">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-background-50 text-accent-700 ring-1 ring-accent-200">
            <i className="ri-archive-2-line text-xl" />
          </span>
          <div className="min-w-0">
            <p className="ds-badge bg-background-50 text-accent-800 ring-1 ring-accent-200">
              <i className="ri-history-line" />
              已保存報告
            </p>
            {timeText && <p className="mt-1.5 text-base text-foreground-600">保存時間：{timeText}</p>}
            {legacy && (
              <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-accent-700">
                此報告建立於歷史追蹤功能啟用前，因此不會自動出現在新的歷史紀錄列表。
              </p>
            )}
          </div>
        </div>
        <button
          type="button"
          onClick={onReturnToLive}
          className="inline-flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-background-400 bg-background-50 px-5 text-base font-semibold text-foreground-700 transition-colors hover:bg-background-100 sm:w-auto"
        >
          <i className="ri-arrow-go-back-line text-lg" />
          返回本次健診
        </button>
      </div>
    </section>
  );
}